module.exports = __webpack_public_path__ + "img/home_five_bg_phone.76b36c1c.png";